<script setup>
import { Tippy } from 'vue-tippy'

const props = defineProps({
  placement: {
    type: String,
    default: 'top-end',
  },
  backdrop: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['show'])
const backdrop = ref(false)
const tippyRef = ref(null)

function openTooltip() {
  backdrop.value = true
  emit('show', true)
}

function closeTooltip() {
  backdrop.value = false
  emit('show', false)
}

function hide() {
  tippyRef.value.hide()
}

const body = ref(null)
onMounted(() => {
  body.value = document.body
})

defineExpose({
  hide,
})
</script>

<template>
  <Tippy
    ref="tippyRef"
    :on-show="openTooltip"
    :on-hide="closeTooltip"
    :placement="placement"
    :append-to="body"
    trigger="click"
    :interactive="true"
    :delay="0"
    :duration="0"
  >
    <div :class="{ trigger: backdrop }">
      <slot name="default" />
    </div>
    <template #content>
      <div class="content" data-cy="tooltip-content">
        <slot name="tooltip" />
      </div>
    </template>
  </Tippy>
  <div v-if="props.backdrop & backdrop" class="backdrop" />
</template>

<style lang="scss" scoped>
.trigger {
  position: relative;
  z-index: 20;
}

.content {
  z-index: 20;
}

.backdrop {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.8;
}
</style>
